exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".web-flows-invest-agreement-___style__terms___2uMu0{padding-right:2em}.web-flows-invest-agreement-___style__terms___2uMu0>li{padding-bottom:.2em}.web-flows-invest-agreement-___style__footer___3CKpi{display:flex;justify-content:center;margin-top:2em}", ""]);

// exports
exports.locals = {
	"terms": "web-flows-invest-agreement-___style__terms___2uMu0",
	"footer": "web-flows-invest-agreement-___style__footer___3CKpi"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]&?minimize=true!./web/flows/invest/agreement/style.css
// module id = 1358
// module chunks = 0